import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import apis from "./apis";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import SjComponents from "sj_components/src/components";
// import VConsole from "vconsole";
// new VConsole();
Vue.use(SjComponents);
Vue.use(ElementUI);
import "@/assets/styles/main.less";

Vue.config.productionTip = false;
Vue.prototype.$apis = apis;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
